import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export interface MenuItem {
  id: number
  label: string
  path: string
  icon?: string
  order: number
  is_active: boolean
  parent_id?: number
  created_at: string
  updated_at?: string
  role_permissions: RolePermission[]
  children?: MenuItem[]
}

export interface RolePermission {
  id: number
  menu_id: number
  role: string
  can_access: boolean
  created_at: string
  updated_at?: string
}

export interface CreateMenuItemRequest {
  label: string
  path: string
  icon?: string
  order?: number
  parent_id?: number
  role_permissions: Omit<RolePermission, 'id' | 'menu_id' | 'created_at' | 'updated_at'>[]
}

export interface UpdateMenuItemRequest {
  label?: string
  path?: string
  icon?: string
  order?: number
  parent_id?: number
  is_active?: boolean
  role_permissions?: Omit<RolePermission, 'id' | 'menu_id' | 'created_at' | 'updated_at'>[]
}

export interface Role {
  value: string
  label: string
}

export const menusApi = {
  getMenuItems: (role?: string) => {
    const params = role ? { role } : {}
    return api.get<ApiResponse<MenuItem[]>>('/menu', { params })
  },

  getAllMenuItems: () =>
    api.get<ApiResponse<MenuItem[]>>('/menu/all'),

  getAvailableRoles: () =>
    api.get<ApiResponse<Role[]>>('/menu/roles'),

  createMenuItem: (data: CreateMenuItemRequest) =>
    api.post<ApiResponse<MenuItem>>('/menu', data),

  updateMenuItem: (id: number, data: UpdateMenuItemRequest) =>
    api.put<ApiResponse<MenuItem>>(`/menu/${id}`, data),

  deleteMenuItem: (id: number) =>
    api.delete<ApiResponse>(`/menu/${id}`),

  restoreMenuItem: (id: number) =>
    api.put<ApiResponse<MenuItem>>(`/menu/${id}/restore`),

  getDeletedMenuItems: () =>
    api.get<ApiResponse<MenuItem[]>>('/menu/deleted'),

  permanentDeleteMenuItem: (id: number) =>
    api.delete<ApiResponse>(`/menu/${id}/permanent`),

  reorderMenuItems: (items: { id: number; order: number }[]) =>
    api.put<ApiResponse>('/menu/reorder', { items })
}

